import logo_light from '../assets/images/logo_white.svg';
import logo_dark from '../assets/images/logo_dark.svg';

const Logo = (props) => {
    return (
        <img src={props.variant && props.variant === 'light' ? logo_light : logo_dark} alt="logo" />
    );
}

export default Logo;